import { TFunction } from 'i18next';
import _find from 'lodash/find';
import {
  EdmDocumentRenewalReminderTemplateFragmentFragment,
  DocumentationRenewalRepetitionEnum,
} from 'graphql-common';
import DocumentFormFieldNames from '@lib/enums/fieldNames/documentFormFieldNames';
import { Values } from '@lib/interfaces/form';
import getRenewalRepetitionOptions from 'routes/Documentation/DocumentForm/utils/getRenewalRepetitionOptions';

export default function getDefaultValues(
  t: TFunction<'translation', undefined>,
  template?: EdmDocumentRenewalReminderTemplateFragmentFragment | null,
): Values {
  const options = getRenewalRepetitionOptions(t);

  if (!template) {
    return {
      [DocumentFormFieldNames.RenewalReminderEnabled]: true,
      [DocumentFormFieldNames.RenewalReminderRepetition]: options[0],
      [DocumentFormFieldNames.RenewalReminderEarlyAmount]: 1,
    };
  }

  const {
    renewalRepetition,
    renewalRepetitionCustomDays,
    renewalEarlyReminderDays,
    renewalDeadlineMd,
  } = template;

  const enabled = !!(
    renewalRepetition ||
    renewalDeadlineMd ||
    renewalEarlyReminderDays ||
    renewalRepetitionCustomDays
  );

  const repetitionOption =
    _find(options, ({ value }) => value === renewalRepetition) || options[0];

  return {
    [DocumentFormFieldNames.RenewalReminderEnabled]: enabled,
    [DocumentFormFieldNames.RenewalReminderRepetition]: repetitionOption,
    [DocumentFormFieldNames.RenewalReminderDeadlineDate]:
      renewalDeadlineMd || '',
    [DocumentFormFieldNames.RenewalReminderCustomDays]:
      renewalRepetition === DocumentationRenewalRepetitionEnum.Custom &&
      renewalRepetitionCustomDays
        ? renewalRepetitionCustomDays
        : '',
    [DocumentFormFieldNames.RenewalReminderEarlyAmount]:
      renewalEarlyReminderDays ?? 1,
  };
}
